import React, { ReactNode } from 'react';
import { SubjectType } from '@surveycake/logic-engine';
import { Overlay } from 'app/pages/Survey/Subject/elements';
import { useSubjectContainer } from './hooks';
import { useStyles } from './styles';

export interface SubjectContainerProps {
  children: (type: SubjectType) => ReactNode;
}

export default function SubjectContainer({ children }: SubjectContainerProps) {
  const {
    id,
    type,
    indent,
    hasTimer,
    visible,
    enable,
    singleSubjectPerPage
  } = useSubjectContainer();
  const styles = useStyles([indent, type, singleSubjectPerPage, hasTimer]);

  if (!visible) {
    return null;
  }

  return (
    <div
      className={styles.subject}
      aria-label="subject"
      data-subject-type={type}
      data-subject-id={id}
    >
      {!enable && <Overlay />}
      {children(type)}
    </div>
  );
}
